<template>
  <div class="tag-view">
    <image-toolbox :selectedNum="selectedNum" :selectedType="selectedType" v-on:closeSelected="closeSelected" v-on:selectedAll="selectedAll" v-on:cancelSelectedAll="cancelSelectedAll" :selectedImages="selectedImages" :loadedAllImageNum="tags.length"></image-toolbox>
    <div class="view-content tag-view-content clearfix">
      <div class="fixed-line clearfix" :class="{'show': tags.length > 0}">
        <div class="total-item">{{$t('list.total')}} {{total}} {{$t('list.items')}}</div>
      </div>
      <div class="view-item tag-item" :class="{'selected': tag.selected}" v-for="(tag, index) in tags" :key="index" @click="goTagDetail(index)">
        <div class="wrapper">
          <div class="layer layer-under"></div>
          <div class="layer layer-middle"></div>
          <div class="layer layer-upper"></div>
          <img class="bookmark" src="../../assets/images/bookmark.png" alt="">
          <div class="img-wrap" :class="{'img-wrap-empty': tag.count === 0}">
            <img class="defaul-tag-img" :src="tag.smallUrl" alt="">
            <span class="empty-text">{{$t('list.empty')}}</span>
          </div>
          <div class="view-item-t tag-msg">
            <span class="tag-title">{{tag.name}}（{{tag.count}}）</span>
          </div>
          <div class="checkbox" @click.stop="selectedFn(index)"></div>
        </div>
        <div class="tag-mark"></div>
      </div>
      <div class="no-file" v-if="showNoFile">
        <div class="no-file-main">
          <img src="../../assets/images/no_file.png" alt="">
          <div>{{$t('list.noFile')}}</div>
        </div>
      </div>
    </div>
    <processing :processing="processing"></processing>
  </div>
</template>

<script>
import * as Config from 'common/script/config'
import HttpClient from 'common/script/http'
import Tags from 'common/model/Tags'
import ImageToolbox from './ImageToolbox'
import Processing from './Processing'
export default {
  name: 'tagView',
  components: {ImageToolbox, Processing},
  data () {
    return {
      total: 0,
      tags: [],
      selectedNum: 0,
      showNoFile: false,
      processing: true,
      selectedType: 2
    }
  },
  created () {
    var obj = this
    setTimeout(function () {
      obj.requestTagsList()
      obj.requetTagsNum()
    }, 100)
  },
  computed: {
    selectedImages () {
      var selectedImages = []
      for (var i = 0; i < this.tags.length; i++) {
        if (this.tags[i].selected) {
          selectedImages.push(this.tags[i])
        }
      }
      return selectedImages
    }
  },
  methods: {
    requestTagsList: function () {
      HttpClient.getData(Config.APP_HOST + '/v1/book/getTagByUserId?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID), this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          // console.log(response)
          this.processing = false
          for (var i = 0; i < response.body.length; i++) {
            var t = response.body[i]
            var tag = new Tags()
            tag.loadData(t)
            this.tags.push(tag)
          }
          if (this.tags.length <= 0) {
            this.showNoFile = true
          }
        }
      })
    },
    requetTagsNum: function () {
      HttpClient.getData(Config.APP_HOST + '/v1/book/getTagCountByUserId?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID), this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          this.total = response.body
        }
      })
    },
    // 之前的
    goTagDetail: function (index) {
      if (this.selectedNum > 0) {
        this.selectedFn(index)
        return
      }
      this.$router.push({path: '/notebook/tag/tagDetail', query: {name: this.tags[index].name}})
    },
    cancelSelectedAll: function () {
      this.closeSelected()
    },
    selectedAll: function () {
      for (var i = 0; i < this.tags.length; i++) {
        this.tags[i].selected = true
      }
      this.selectedNum = this.tags.length
    },
    closeSelected: function () {
      for (var i = 0; i < this.tags.length; i++) {
        this.tags[i].selected = false
      }
      this.selectedNum = 0
    },
    selectedFn: function (index) {
      this.tags[index].selected = !this.tags[index].selected
      if (this.tags[index].selected) {
        this.selectedNum += 1
      } else {
        this.selectedNum -= 1
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.tag-view-content
  padding 90px 0 50px 30px
  .fixed-line
    display none
    &.show
      display block
.tag-item
  display block
  justify-content center
  align-items center
  position relative
  transition all .3s ease
  cursor pointer
  &.selected
    .checkbox
      display block
      background-image url('../../assets/images/checkbox_click.png')
  &:hover
    .wrapper
      top -8px
      .img-file
        box-shadow rgba(218, 218, 218, 0.64) 0px 6px 30px 5px
      .layer
        &.layer-under
          width 154px
          height 170px
          top -2px
          margin-left -77px
          box-shadow rgba(218, 218, 218, 0.64) 0px 6px 30px 5px
        &.layer-middle
          width 166px
          height 170px
          top 5px
          margin-left -83px
          box-shadow rgba(218, 218, 218, 0.64) 0px 17px 50px 0px
        &.layer-upper
          width 178px
          height 170px
          top 12px
          margin-left -89px
          box-shadow rgba(218, 218, 218, 0.64) 0px 17px 45px -10px
    .checkbox
      display block
  .wrapper
    display flex
    width 100%
    height 100%
    flex-direction row
    justify-content center
    align-items center
    position relative
    transition all .3s ease
    cursor pointer
  .img-file
    width 100%
    height 100%
    max-width 100%
    max-height 100%
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    margin auto
    transition all .3s ease
    img
      max-width 100%
      max-height 100%
      transition all .3s ease
  .layer
    position absolute
    left 50%
    border 1px solid #e5e5e5
    border-radius 4px
    background-color #fff
    transition all .25s ease
    &.layer-under
      width 160px
      height 170px
      top 0
      margin-left -80px
      transition all .25s ease-in
    &.layer-middle
      width 170px
      height 170px
      top 6px
      margin-left -85px
      transition all .25s ease-in
    &.layer-upper
      width 178px
      height 170px
      top 12px
      margin-left -89px
  .bookmark
    position absolute
    top 12px
    left 9px
  .img-wrap
    width 120px
    height 120px
    position absolute
    top 25px
    left 50%
    margin-left -60px
    background-color #fafafa
    border-radius 4px
    display flex
    justify-content center
    align-items center
    img
      max-width 100%
      max-height 100%
      display block
      &.folder-img
        display block
    .empty-text
      font-size 14px
      color #ddd
      font-weight bold
      display none
    &.img-wrap-empty
      width 100px
      height 100px
      margin-left -50px
      top 37px
      background-color #fff
      border-radius 50%
      border 12px solid #fafafa
      box-sizing border-box
      img
        display none
      .empty-text
        display block
  .tag-msg
    .tag-title
      color #3d3d3d
      font-weight 500
      display inline-block
      max-width 119px
      height 12px
      line-height 12px
      white-space nowrap
      text-overflow ellipsis
      overflow hidden
      vertical-align middle
  .checkbox
    bottom 10px
    right 12px
  .tag-mark
    width 100%
    height 102%
    position absolute
    top -9px
    left 0
    background-color #dedcdc7a
    border-radius 21px 21px 0 0
    display none
</style>



// WEBPACK FOOTER //
// src/components/Notebook/Tags.vue